import { render } from "./AboutPage.vue?vue&type=template&id=3b755da2&scoped=true"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=3b755da2&lang=less&scoped=true"
import "./AboutPage.vue?vue&type=style&index=1&id=3b755da2&lang=less&scoped=true"
import "./AboutPage.vue?vue&type=style&index=2&id=3b755da2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b755da2"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QSeparator,QImg});
